/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MetamodelMe } from '../../models/metamodel-me';

export interface GetMetaModelList$Params {
  orid?: number | null;
}

export function getMetaModelList(http: HttpClient, rootUrl: string, params?: GetMetaModelList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MetamodelMe>>> {
  const rb = new RequestBuilder(rootUrl, getMetaModelList.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MetamodelMe>>;
    })
  );
}

getMetaModelList.PATH = '/api/MetaModel/metamodels';
